import { type ReactNode } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

interface StateMessageProps {
  image?: string;
  imageSize?: { width: number; height?: number };
  title: string;
  description: string;
  action?: { onClick: () => void; label: string; startIcon?: ReactNode };
  backgroundColor?: string;
  customAction?: ReactNode;
  centered?: boolean;
}

export const StateMessage = ({
  title,
  description,
  image,
  imageSize,
  action,
  backgroundColor,
  customAction,
  centered = true,
}: StateMessageProps) => {
  return (
    <Stack
      alignItems={{ xs: 'start', md: centered ? 'center' : undefined }}
      justifyContent={{ xs: 'start', md: centered ? 'center' : undefined }}
      border={
        backgroundColor
          ? 'none'
          : ({ palette }) => `1px solid ${palette.grey[300]}`
      }
      py={{ xs: 3, md: 4 }}
      px={{ xs: 3, md: backgroundColor ? 0 : 4 }}
      borderRadius={({ shape }) => `${shape.borderRadius}px`}
      sx={{ backgroundColor: backgroundColor ?? 'transparent' }}
    >
      <Box
        component="img"
        src={image}
        sx={{ width: imageSize?.width, height: imageSize?.height }}
      />
      <Typography
        variant="h2"
        mb={1}
        mt={3}
        textAlign={{ md: centered ? 'center' : undefined }}
      >
        {title}
      </Typography>
      <Typography textAlign={{ md: centered ? 'center' : undefined }}>
        {description}
      </Typography>
      {(customAction || action) && (
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          justifyContent={{ md: centered ? 'center' : undefined }}
          mt={3}
        >
          {customAction}
          {action && (
            <Button
              variant="contained"
              onClick={action.onClick}
              startIcon={action.startIcon}
            >
              {action.label}
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
};
